import backendAxios from '../utils/backendAxios';

export const submitReview = async (bookingId, rating, comentario) => {
  try {
    const res = await backendAxios.post('/api/reviews', { bookingId, rating, comentario });
    return res.data;
  } catch (err) {
    console.error('Error submitting review', err);
    return null;
  }
};

export const getServiceReviews = async (servicioId) => {
  try {
    const res = await backendAxios.get(`/api/reviews/servicio/${servicioId}`);
    return res.data;
  } catch (err) {
    console.error('Error fetching service reviews', err);
    return [];
  }
};

export const getProviderReviews = async (proveedorId) => {
  try {
    const res = await backendAxios.get(`/api/reviews/proveedor/${proveedorId}`);
    return res.data;
  } catch (err) {
    console.error('Error fetching provider reviews', err);
    return [];
  }
};

export const getClientReviews = async (clienteId) => {
  try {
    const res = await backendAxios.get(`/api/reviews/cliente/${clienteId}`);
    return res.data;
  } catch (err) {
    console.error('Error fetching client reviews', err);
    return null;
  }
};
